import { BoxProvider } from "../../Context/BoxContext";
import BoxWithContent from "../../Components/BoxWithContent";
import { useHrStyles } from "../../Context/HRContext";
import "./Management.css";

export default function Management() {
  const hrStyles = useHrStyles();

  const heading = "Site Management";
  const description =
    "Ensuring efficient and safe site operations from start to finish. At BEAMS, our site management expertise guarantees that every phase of your project is executed smoothly, adhering to the highest standards of safety and quality.";
  const image = "/assets/images/site.jpg";
  const gradientColor = "#FDDBDB";
  const buttonVariant = "outline-warning";
  const link1 = "/Site";

  const heading2 = "Project Management";
  const description2 =
    "Overseeing every detail of your project to ensure success. BEAMS provides comprehensive project management services, handling schedules, budgets, and resources with precision to bring your vision to life without compromise.";
  const image2 = "/assets/images/project.jpg";
  const gradientColor2 = "#FDDBDB";
  const buttonVariant2 = "outline-warning";
  const link2 = "/Project";

  return (
    <>
      <div className="management">
        <BoxProvider
          heading={heading}
          description={description}
          image={image}
          gradientColor={gradientColor}
          buttonVariant={buttonVariant}
          link1={link1}
          heading2={heading2}
          description2={description2}
          image2={image2}
          gradientColor2={gradientColor2}
          buttonVariant2={buttonVariant2}
          link2={link2}
        >
          <hr style={hrStyles} />
          <p className="building-text">
            Managing Projects,
            <br />
            Delivering Excellence
          </p>
          <hr style={hrStyles} />
          <p className="building-description">
            BEAMS takes the stress out of project execution with our expert
            management services. From planning to completion, we ensure seamless
            coordination, quality assurance, and timely delivery for all your
            building and architectural needs.
          </p>
          <BoxWithContent />
        </BoxProvider>
        <hr style={hrStyles} />
      </div>
    </>
  );
}
